import { defineStore } from 'pinia'

export const useGlobalStore = defineStore(
  'global',
  () => {
    const orySession = ref<any>(null)
    const oryLogoutUrl = ref<string>('')
    const isSidebarMinimized = ref<boolean>(false)
    const activeMobileSubscriber = ref<number>(0)
    const activeInternetSubscriber = ref<number>(0)
    const activeOrderSubscriber = ref<number>(0)
    const isMobileMenuOpened = ref<boolean>(false)
    const customerSelectFlowFinished = ref<boolean>(false)

    function setCustomerSelectFlowFinished(status: boolean) {
      customerSelectFlowFinished.value = status
    }

    function clearOrySession() {
      orySession.value = null
    }

    function setOrySession(session: any) {
      orySession.value = session
    }

    function setOryLogoutUrl(url: string) {
      console.debug(`updating logout url to ${url}`)
      oryLogoutUrl.value = url
    }

    return {
      orySession,
      oryLogoutUrl,
      isSidebarMinimized,
      activeMobileSubscriber,
      activeInternetSubscriber,
      activeOrderSubscriber,
      clearOrySession,
      setOrySession,
      setOryLogoutUrl,
      isMobileMenuOpened,
      customerSelectFlowFinished,
      setCustomerSelectFlowFinished,
    }
  },
  {
    persist: {
      storage: sessionStorage,
    },
  },
)
